import axios from "axios"
import { BACKEND_URL, WS_BASE } from '../config'
import { api } from "../services/api"
import { getUserAfterNameChange } from "../../features/auth/authSlice"



// --- Helpers ----------------------------------------------------------------
export const formatTime = (iso) => {
    const d = new Date(iso)
    return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' })
  }

// Deterministic avatar color from a username (that "Discord" feel).
const AVATAR_COLORS = [
    '#5865F2', '#57F287', '#FEE75C', '#EB459E',
    '#ED4245', '#3BA55D', '#FAA61A', '#00A8FC',
  ]
  const colorFor = (name = '') => {
    let hash = 0
    for (let i = 0; i < name.length; i++) hash = name.charCodeAt(i) + ((hash << 5) - hash)
    return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length]
  }


export const parseUserInfo = (u, userInfo) => {
    const user = userInfo.find((user) => user.username === u);
    if(user && userInfo){
        return user && user.color ? user.color : "#7d10d5";
    } 
  }


  export const checkForEmojiLarge = (text) => {
    // 1. Strip out whitespace to prevent spaces from breaking the check
    const cleanText = text.trim();
    
    // 2. Regex matching the modern Unicode Emoji property character set
    const emojiRegex = /^[\p{Emoji_Modifier_Base}\p{Emoji_Component}\p{Emoji_Presentation}\p{Emoji}]{1,3}$/u;
    
    // 3. Exclude plain strings of pure numbers/punctuation that technically trigger the emoji property
    const isPureNumberOrPunctuation = /^[0-9!@#$%^&*(),.?":{}|<>+\-_=[\]\\';`/~]+$/.test(cleanText);

    return emojiRegex.test(cleanText) && !isPureNumberOrPunctuation;

  }


export const handleSettingsSave  = async (user) => {
    // Update settings using API call to DB
    try {
        const token = localStorage.getItem("accessToken")
        console.log("Closing, Saving settings to server");
        // const { data } = await axios.put(`${BACKEND_URL}/api/settings/`, JSON.stringify(user),{ headers: { Authorization : `Bearer ${token}`}})
        const { data } = await api.put(`${BACKEND_URL}/api/settings/`, JSON.stringify(user),{ headers: { Authorization : `Bearer ${token}`}})
        console.log(data)
        return data;
      } catch (err) {
        console.warn("Could not save settings on db:", err?.response?.status)
      }
}

export const handleChangeUserName  = async (username, newname) => {
    // Update settings using API call to DB

    if(!newname) return;
    const payload = {
        username: username,
        newname: newname
    }
    try {

        const token = localStorage.getItem("accessToken")
        console.log("Changing user name on DB");
        // const { data } = await axios.put(`${BACKEND_URL}/api/settings/`, JSON.stringify(user),{ headers: { Authorization : `Bearer ${token}`}})
        const { data } = await api.put(`${BACKEND_URL}/api/changename/`, JSON.stringify(payload),{ headers: { Authorization : `Bearer ${token}`}})
        console.log(data)

        return data;
      } catch (err) {
        console.warn("Could not save settings on db:", err?.response?.status)
      }
}


